import type { UseGetCurrentUserOrganizationOptions } from "./current-user-organization.type";

import { useGetOrganizationMinimal } from "@/entities/organization";

import { useGetCurrentUser } from "../current-user.query";

export const useGetCurrentUserOrganization = (
  options?: UseGetCurrentUserOrganizationOptions
) => {
  const { currentUser, ...userQueryResult } = useGetCurrentUser();

  const organizationId = currentUser?.organization_id;

  const { organization, ...queryResult } = useGetOrganizationMinimal(
    organizationId,
    options
  );

  return {
    ...queryResult,
    currentUser,
    userQueryResult,
    organization,
  };
};
